export const BASE_URL = 'https://medinakas.kg/api/'